import { type SearchHistory } from '../types/GlobalContext';

export const filterSearchHistory = (query: string, isSource: boolean, searchHistory: SearchHistory[]) => {
  // Filter the search history based on the query
  let filteredHistory = searchHistory.filter((item) => item.address.toLowerCase().includes(query.toLowerCase()));

  // Sort the filtered history by date (most recent first)
  filteredHistory = filteredHistory.sort((a, b) => b.date - a.date);

  // Sort by sourceCount or destinationCount
  filteredHistory = filteredHistory.sort((a, b) => {
    const countA = isSource ? a.departureCount : a.arrivalCount;
    const countB = isSource ? b.departureCount : b.arrivalCount;
    return countB - countA;
  });

  filteredHistory = deduplicateHistory(filteredHistory);

  // Return the top 3 elements with added source property
  return filteredHistory.slice(0, 3).map((item) => ({
    ...item,
    source: 'l' as 'l'
  }));
};

export const deduplicateHistory = (searchHistory: SearchHistory[]) => {
  const seenAddresses = new Set<string>();
  searchHistory = searchHistory.filter((item) => {
    if (typeof item.address !== 'string') return false;
    if (seenAddresses.has(item.address.toLowerCase())) return false;
    seenAddresses.add(item.address.toLowerCase());
    return true;
  });
  return searchHistory;
};
